<button #viewMoreButton [hidden]="hidden" class="PGViewMore btn btn-block btn-white text-muted" (click)="viewMore.emit()"><i class="fa-regular fa-ellipsis"></i></button>
